import React, {useCallback, useState, useEffect} from 'react'
import FromFieldDate from '../../../atoms/FromFieldDate';
import "react-datepicker/dist/react-datepicker.css";
import {getDepresiationSummery} from '../../../services/asset.service';
import {getClasificationsList} from '../../../services/user.service';
import * as CryptoJS from "crypto-js";
import '../AssetInfo/AssetList.css';
//import '../AssetInfo/DataGridStyles.css';
import './DepreciationSummaryStyles.css';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

/* ─── Print Function (unchanged logic) ─── */
const printSummary = function () {
    let printContents = document.getElementById('print_summary').innerHTML;
    var docprint = window.open();
    docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
    docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
    docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
    docprint.document.write('<head><title>Depreciation Summary</title>');
    docprint.document.write('<style type="text/css">thead tr:nth-child(2) th:nth-child(1) { background: #44546a; width: 135px;#dep_summary{ text-align: right;}}</style>');
    docprint.document.write('</head><body onLoad="self.print()"><center>');
    docprint.document.write(printContents);
    docprint.document.write('</center></body></html>');
    docprint.document.close();
    docprint.focus();
    docprint.print();
    document.getElementById('print_qr').innerHTML = '';
}

function DepreciationSummary() {
    /* ─── All State (unchanged) ─── */
    const [fromperiod, setFromPeriod] = useState('');
    const [ErrFromPeriod, setErrFromPeriod] = useState('');
    const [toperiod, setToPeriod] = useState();
    const [ErrToPeriod, setErrToPeriod] = useState('');
    const [classifications, setClasifications] = useState([]);
    const [assetInfo, setAssetInfo] = useState([]);
    const [loading, setLoading] = useState(false);

    /* ─── Fetch Classifications (unchanged logic) ─── */
    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getClasificationsList(oData).then(res => {
            if (res?.data?.data?.length) setClasifications(res.data.data);
        });
    }, []);

    /* ─── Get Summary Info (unchanged logic) ─── */
    const getSummeryInfo = async () => {
        const aSummery = [];
        
        if (fromperiod !== '' && fromperiod !== null) {
            setErrFromPeriod('');
        } else {
            setErrFromPeriod('Please select From Date');
            return false;
        }
        if (toperiod !== '' && toperiod !== null) {
            setErrToPeriod('');
        } else {
            setErrToPeriod('Please select To Date');
            return false;
        }
        
        setLoading(true);
        
        classifications.map(async (val) => {
            let obj = {
                'fnclass': val.id,
                'fnclasscategory': val.category_name,
                'from_date': getFormatedDate(fromperiod),
                'to_date': getFormatedDate(toperiod),
            };
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = {'token': EncryptData}
            await getDepresiationSummery(oData1).then(function (res) {
                let asset_ob = 0;
                let asset_cb = 0;
                let asset_added_value = 0;
                let asset_deleted_value = 0;
                let depreciation_added_value = 0;
                let depreciation_adjusted_value = 0;
                let depreciation_deleted_value = 0;
                let depreciation_ob = 0;
                let new_depreciation_cb = 0;
                let wdv_ob = 0;
                let wdv_cb = 0;
                if (res?.data?.data?.assetDeprisiation) {
                    var aAssetInfo = res.data.data.assetDeprisiation;
                    aAssetInfo.map(async (oInfo) => {
                        asset_ob = oInfo.asset_ob + asset_ob;
                        asset_cb = oInfo.asset_cb + asset_cb;
                        asset_added_value = oInfo.asset_added_value + asset_added_value;
                        asset_deleted_value = oInfo.asset_deleted_value + asset_deleted_value;
                        depreciation_added_value = oInfo.depreciation_added_value + depreciation_added_value;
                        depreciation_adjusted_value = oInfo.depreciation_adjusted_value + depreciation_adjusted_value;
                        depreciation_deleted_value = oInfo.depreciation_deleted_value + depreciation_deleted_value;
                        depreciation_ob = oInfo.depreciation_ob + depreciation_ob;
                        new_depreciation_cb = oInfo.new_depreciation_cb + new_depreciation_cb;
                        wdv_ob = oInfo.wdv_ob + wdv_ob;
                        wdv_cb = oInfo.wdv_cb + wdv_cb;
                    })
                }
                aSummery.push({
                    'fnclass': val.category_name,
                    'asset_ob': asset_ob,
                    'asset_cb': asset_cb,
                    'asset_added_value': asset_added_value,
                    'asset_deleted_value': asset_deleted_value,
                    'depreciation_added_value': depreciation_added_value,
                    'depreciation_adjusted_value': depreciation_adjusted_value,
                    'depreciation_deleted_value': depreciation_deleted_value,
                    'depreciation_ob': depreciation_ob,
                    'depreciation_cb': new_depreciation_cb,
                    'wdv_cb': wdv_cb,
                    'wdv_ob': wdv_ob,
                });
            });
        });
        setAssetInfo(aSummery);
        setLoading(false);
    };

    const formatAmount = (value) => {
        const num = Number(value);
        if (isNaN(num)) return "0.00";

        return num.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };
    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="depreciation-summary-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-calculator-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">I-GAAP Depreciation Summary</h5>
                        <p className="al-page-subtitle">Financial classification-wise depreciation analysis</p>
                    </div>
                </div>
                {assetInfo.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-grid-3x3-gap-fill"/>
                        <strong>{assetInfo.length}</strong>&nbsp;Classifications
                    </div>
                )}
            </div>

            {/* ══ DATE FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-calendar-range-fill"/> Select Date Range
                    </span>
                </div>
                <div className="al-filter-card-body">
                    <div className="al-date-grid" style={{gridTemplateColumns: '1fr 1fr auto auto'}}>
                        <div className="al-filter-group">
                            <FromFieldDate
                                star="*"
                                label="From Date"
                                inputValue={fromperiod}
                                setInputValue={setFromPeriod}
                                setErrorMsg={ErrFromPeriod}
                            />
                        </div>
                        <div className="al-filter-group">
                            <FromFieldDate
                                star="*"
                                label="To Date"
                                inputValue={toperiod}
                                setInputValue={setToPeriod}
                                setErrorMsg={ErrToPeriod}
                            />
                        </div>
                        <div className="al-filter-group" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <button className="al-btn al-btn-primary" onClick={getSummeryInfo} disabled={loading}>
                                {loading ? (
                                    <><span className="al-dot"/><span className="al-dot"/><span className="al-dot"/> Loading…</>
                                ) : (
                                    <><i className="bi bi-search"/> Fetch Data</>
                                )}
                            </button>
                        </div>
                        <div className="al-filter-group" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <button className="al-btn al-btn-outline" onClick={printSummary}>
                                <i className="bi bi-printer-fill"/> Print Summary
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ══ DEPRECIATION SUMMARY TABLE ══ */}
            <div className="ds-table-card" id="print_summary">
                <div className="ds-table-card-header">
                    <span className="ds-table-card-title">
                        <i className="bi bi-table"/> I-GAAP Depreciation Summary
                    </span>
                </div>
                
                <div className="ds-table-container" id="dep_summary">
                    <table className="ds-table">
                        <thead>
                            <tr className="ds-header-main">
                                <th colSpan={12}>I-GAAP Depreciation</th>
                            </tr>
                            <tr className="ds-header-section">
                                <th rowSpan={2} className="ds-classification-header">Financial Classification</th>
                                <th colSpan={4} className="ds-section-asset">Asset Value</th>
                                <th colSpan={5} className="ds-section-depreciation">Depreciation</th>
                                <th colSpan={2} className="ds-section-netblock">Net Block</th>
                            </tr>
                            <tr className="ds-header-columns">
                                <th className="ds-col-asset">Opening Value</th>
                                <th className="ds-col-asset">Addition</th>
                                <th className="ds-col-asset">Deletion</th>
                                <th className="ds-col-asset">Closing Value</th>
                                <th className="ds-col-depreciation">Opening Acc Dep</th>
                                <th className="ds-col-depreciation">Addition for the Period</th>
                                <th className="ds-col-depreciation">Deletion for the Period</th>
                                <th className="ds-col-depreciation">Adjustment for the Period</th>
                                <th className="ds-col-depreciation">Closing Acc Dep</th>
                                <th className="ds-col-netblock">Opening WDV</th>
                                <th className="ds-col-netblock">Closing WDV</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assetInfo.map((asset_info, index) => (
                                <tr key={index} className="ds-data-row">
                                    <td className="ds-classification-cell">{asset_info.fnclass || 0}</td>
                                    <td className="ds-price-cell">{formatAmount(asset_info.asset_ob)}</td>
                                    <td className="ds-price-cell">{formatAmount(asset_info.asset_added_value)}</td>
                                    <td className="ds-price-cell">{formatAmount(asset_info.asset_deleted_value)}</td>
                                    <td className="ds-price-cell">{formatAmount(asset_info.asset_cb)}</td>
                                    <td className="ds-price-cell ds-depreciation-cell">{formatAmount(asset_info.depreciation_ob)}</td>
                                    <td className="ds-price-cell ds-depreciation-cell">{formatAmount(asset_info.depreciation_added_value)}</td>
                                    <td className="ds-price-cell ds-depreciation-cell">{formatAmount(asset_info.depreciation_deleted_value)}</td>
                                    <td className="ds-price-cell ds-depreciation-cell">{formatAmount(asset_info.depreciation_adjusted_value)}</td>
                                    <td className="ds-price-cell ds-depreciation-cell">{formatAmount(asset_info.depreciation_cb)}</td>
                                    <td className="ds-price-cell ds-netblock-cell">{formatAmount(asset_info.wdv_ob)}</td>
                                    <td className="ds-price-cell ds-netblock-cell">{formatAmount(asset_info.wdv_cb)}</td>
                                </tr>
                            ))}
                            {assetInfo.length > 0 && (
                                <tr className="ds-total-row">
                                    <td className="ds-total-label">Grand Total</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            )}
                            {assetInfo.length === 0 && (
                                <tr>
                                    <td colSpan={12} className="ds-no-data">
                                        <i className="bi bi-info-circle"/> No data available. Please select dates and click "Fetch Data".
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            
            {/* Hidden print div */}
            <div id="print_qr" style={{display: 'none'}}></div>
        </div>
    )
}

export default DepreciationSummary